/**
 * Nsection B5 Service
 * B.5.適用條件 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b5';

export interface SubParagraphItem {
  content: string;
}

export interface ApplicabilityConditionItem {
  paragraph: string;
  sub_paragraphs: SubParagraphItem[];
}

export interface NsectionB5Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  applicability_conditions: ApplicabilityConditionItem[] | null;
  nsection_b5_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB5Update {
  applicability_conditions?: ApplicabilityConditionItem[];
}

const nsectionB5Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB5Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB5Update): Promise<NsectionB5Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB5Service;
